import { render } from "./ArtworksView.vue?vue&type=template&id=1a05439a&scoped=true&ts=true"
import script from "./ArtworksView.vue?vue&type=script&lang=ts"
export * from "./ArtworksView.vue?vue&type=script&lang=ts"

import "./ArtworksView.vue?vue&type=style&index=0&id=1a05439a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a05439a"]])

export default __exports__